import docCookies from 'doc-cookies';
import { load } from 'recaptcha-v3';
import { xsfrToken } from '../alpine-functions';
import { RECAPTCHA_SITE_KEY } from '../misc/consts';

export default () => ({
  form: null,
  sent: false,
  sending: false,
  failed: false,

  init() {
    this.form = this.$el;
  },

  get action() {
    return this.form.action;
  },

  resetForm() {
    this.sent = false;
    this.form.reset();
  },

  isValid() {
    return this.form.reportValidity();
  },

  async getRecaptchaToken(action) {
    const recaptcha = await load(RECAPTCHA_SITE_KEY);
    return await recaptcha.execute(action);
  },

  /**
   * Odeslání dat do Google Tag Manager (GTM) přes DataLayer
   */
  pushToDataLayer(formType, formEmail, formPhone) {
    console.log('pushToDataLayer', formType, formEmail, formPhone);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_sent',
      formType: formType,
      formEmail: formEmail,
      formPhone: formPhone,
    });
  },

  async send() {
    if (!this.isValid()) {
      return false;
    }
    this.sending = true;

    await xsfrToken();

    const data = new URLSearchParams(new FormData(this.form));

    const recaptchaAction = this.action.replace(/[^A-Za-z]/g, '');
    const token = await this.getRecaptchaToken(recaptchaAction);

    data.append('recaptcha_token', token);
    data.append('recaptcha_action', recaptchaAction);

    return await fetch(this.action, {
      body: data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
      },
      method: 'POST',
    })
      .then(async (response) => {
        if (response.ok) {
          this.sent = true;
          this.sending = false;

          // Rozlišení typu formuláře na základě lead_type
          const formType =
            data.get('lead_type') === 'consultation'
              ? 'Chci konzultaci'
              : 'Kontakt makléře';

          let formEmail = '';
          let formPhone = '';

          if (formType === 'Chci konzultaci') {
            // Formulář "Chci konzultaci" má pole email a phone
            formEmail = data.get('email') || '';
            formPhone = data.get('phone') || '';
          } else {
            // Formulář "Kontakt makléře" má pouze pole contact (buď e-mail, nebo telefon)
            const contactValue = data.get('contact') || '';
            formEmail = contactValue.includes('@') ? contactValue : '';
            formPhone = !contactValue.includes('@') ? contactValue : '';
          }

          // Odeslání eventu do GTM
          this.pushToDataLayer(formType, formEmail, formPhone);

          // Zpracování konverzí
          const conversionID =
            formType === 'Chci konzultaci' ? 100185168 : 100185076;
          const conversionConf = {
            id: conversionID,
            value: null,
          };

          if (window.rc && window.rc.conversionHit) {
            window.rc.conversionHit(conversionConf);
          }
          return true;
        }
        throw new Error('Something went wrong.');
      })
      .catch((error) => {
        console.error('Error:', error);
        this.sent = true;
        this.sending = false;
        this.failed = true;
      });
  },
});
